import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconsModule } from "@mk/med-icons";

import { MedSearchBarComponent } from "./med-search-bar.component";
import { MedInputModule } from "../form/med-input/med-input.module";
import { MedDirectiveSharedModule } from "../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedSearchBarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedIconsModule,
    MedInputModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedSearchBarComponent,
  ],
})
export class MedSearchBarModule { }
